"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { isUrl } from "../utils";
export const Facebook = /*#__PURE__*/ React.forwardRef(function Facebook(_param, ref) {
    var { className = "", layout = "standard", width = 250, height = 50, url = "https://facebook.com/webflow", locale = "en_US" } = _param, props = _object_without_properties(_param, [
        "className",
        "layout",
        "width",
        "height",
        "url",
        "locale"
    ]);
    if (!isUrl(url)) {
        url = "https://facebook.com/webflow";
    }
    if (!/^http/.test(url)) {
        url = "http://" + url;
    }
    const params = {
        href: url,
        layout,
        locale,
        action: "like",
        show_faces: "false",
        share: "false"
    };
    const queryParams = Object.keys(params).map((key)=>`${key}=${encodeURIComponent(params[key])}`);
    const frameSrc = `https://www.facebook.com/plugins/like.php?${queryParams.join("&")}`;
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        className: className + " w-widget w-widget-facebook",
        ref: ref
    }), /*#__PURE__*/ React.createElement("iframe", {
        title: "Facebook Like Button",
        src: frameSrc,
        style: {
            border: "none",
            overflow: "hidden",
            width,
            height
        }
    }));
});
